export const DISPLAY_LARGE = 'mb-0 align-self-center d-none d-xl-block';
export const DISPLAY_SMALL = 'd-block d-xl-none';